module.exports = __webpack_public_path__ + "static/media/familyAndBill55.170320a2.png";